import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-trip-clm-history-screen',
    templateUrl: './trip-clm-history-screen.component.html',
    styleUrls: ['./trip-clm-history-screen.component.scss'],
})
export class TripClmHistoryScreenComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
